// Function to initialize routes with components

import { RouteKey, ROUTES_LIST } from "./Routes";

const ROUTES_WITHOUT_EVENTS = [
  "administration",
  "workspaces",
  "presets",
  "events",
];

const ROUTES: Record<RouteKey, string> = {} as Record<RouteKey, string>;

const ROUTE_PATH_TO_ROUTE_KEY: Record<string, string> = {} as Record<
  string,
  string
>;

Object.entries(ROUTES_LIST).forEach(([key, value]) => {
  ROUTES[key as RouteKey] = value.route || `$$${key.toLowerCase()}`;
  ROUTE_PATH_TO_ROUTE_KEY[value.route || `$$${key.toLowerCase()}`] = key;
});

const getRouteMap = (target: RouteKey) => {
  return ROUTES_LIST[ROUTE_PATH_TO_ROUTE_KEY[target]]?.routeMap;
};

export const routePagesFinder = (pathname: string): string[] => {
  const pages: string[] = [];

  if (!pathname) return pages;

  Object.keys(ROUTES_LIST).forEach((key) => {
    const value =
      ROUTES_LIST[key as keyof typeof ROUTES_LIST]?.frontendPageNames || [];

    const target = pathname.toLowerCase();

    if (value.some((page) => page.toLowerCase() === target)) {
      pages.push(key);
    }
  });

  return pages;
};

const checkRouteValidity = () => {
  const url = window.location.pathname;
  const [_, first, second] = url.split("/");
  const isNumber = (str: string) => /^[0-9]*$/.test(str);
  const routeHasEventId = first ? isNumber(first) : null;
  const routeShouldHaveEventId = !ROUTES_WITHOUT_EVENTS.includes(second);
  const base = routeHasEventId ? second : first;
  const eventId = routeHasEventId ? first : null;
  return { routeHasEventId, routeShouldHaveEventId, base, eventId };
};

const extractBaseURL = () => {
  const { base } = checkRouteValidity();
  return base;
};

const getSmartRoute = (PermissionType: "API" | "ROUTING") => {
  const baseURL = extractBaseURL();
  let pageName = "";
  const isApiPermission = PermissionType === "API";

  const routeObject = Object.entries(ROUTES_LIST).find(([_key, value]) => {
    if (isApiPermission) {
      return value.backendPageNames.includes(baseURL);
    }

    return value.frontendPageNames.includes(baseURL);
  })?.[1];

  if (routeObject) {
    pageName = routeObject.route;
  }

  return pageName;
};

const getEventId = () => {
  const { eventId } = checkRouteValidity();
  return eventId;
};

export {
  ROUTES,
  getRouteMap,
  getSmartRoute,
  getEventId,
  ROUTES_WITHOUT_EVENTS,
  extractBaseURL,
  checkRouteValidity,
  ROUTE_PATH_TO_ROUTE_KEY,
};
